import { render } from "./WhoSheWorksWith.vue?vue&type=template&id=dd978176&scoped=true"
const script = {}

import "./WhoSheWorksWith.vue?vue&type=style&index=0&id=dd978176&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd978176"]])

export default __exports__